import { createContext, ReactNode, useContext } from 'react';

interface SelectContextProps<T> {
  children: ReactNode;
  color: 'primary' | 'secondary' | 'sand';
  onChange(value: T): void;
  selectedText?: ReactNode;
  setSelectedText(text: ReactNode): void;
  value: T;
}

type SelectContext<T> = Omit<SelectContextProps<T>, 'children'>;

const Context = createContext<SelectContext<any> | undefined>(undefined);

export function SelectContext<T>(props: SelectContextProps<T>) {
  const {
    children,
    color = 'primary',
    onChange,
    selectedText,
    setSelectedText,
    value,
  } = props;

  return (
    <Context.Provider
      value={{ color, onChange, selectedText, setSelectedText, value }}
    >
      {children}
    </Context.Provider>
  );
}

export const useSelectContext = () => {
  const context = useContext(Context);

  if (context === undefined)
    throw new Error('useSelectContext must be used within a SelectContext');

  return context;
};
